module.exports = __webpack_public_path__ + "img/sort-bottom.1522ed58.svg";